import { Heart, X, ShieldCheck, MapPin } from "lucide-react";

// Illustrative product mock — NOT real user data.
export function DiscoverPreview() {
  return (
    <div className="w-full max-w-[300px] overflow-hidden rounded-[1.75rem] border border-emerald-900/10 bg-white shadow-[0_24px_60px_-24px_rgba(11,74,63,0.45)]">
      <div className="relative aspect-[4/5] bg-gradient-to-br from-emerald-700 via-emerald-800 to-emerald-950">
        <div className="absolute inset-0 flex items-center justify-center">
          <svg viewBox="0 0 24 24" className="h-28 w-28 text-emerald-300/40" fill="currentColor"><path d="M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-4 0-8 2-8 6v2h16v-2c0-4-4-6-8-6z" /></svg>
        </div>
        <span className="absolute left-3 top-3 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-emerald-800 shadow-sm">92% Match</span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-blue-600 px-2 py-1 text-[10px] font-semibold text-white"><ShieldCheck className="h-3 w-3" /> Wali</span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-950/95 to-transparent p-4 pt-10">
          <p className="font-serif text-xl font-bold text-white">Member, 27</p>
          <p className="flex items-center gap-1 text-xs text-emerald-100/80"><MapPin className="h-3 w-3" /> London, UK</p>
          <div className="mt-2 flex flex-wrap gap-1">
            <span className="rounded-full bg-white/15 px-2 py-0.5 text-[10px] text-white">Sunni</span>
            <span className="rounded-full bg-white/15 px-2 py-0.5 text-[10px] text-white">Prays 5×</span>
            <span className="rounded-full bg-white/15 px-2 py-0.5 text-[10px] text-white">Family-focused</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-3 p-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-red-200 text-red-500"><X className="h-5 w-5" /></span>
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-700 text-white shadow-md"><Heart className="h-5 w-5" /></span>
      </div>
    </div>
  );
}

export function CompatibilityPreview() {
  const rows = [
    { label: "Deen & practice", val: 95 },
    { label: "Family values", val: 88 },
    { label: "Lifestyle", val: 79 },
    { label: "Goals", val: 84 },
  ];
  return (
    <div className="w-full max-w-[280px] rounded-[1.5rem] border border-emerald-900/10 bg-white p-5 shadow-[0_20px_50px_-24px_rgba(11,74,63,0.4)]">
      <div className="mb-4 flex items-center gap-3">
        <div className="relative flex h-16 w-16 items-center justify-center rounded-full" style={{ background: "conic-gradient(#0E6E5C 0% 87%, #E7F3EE 87% 100%)" }}>
          <div className="flex h-12 w-12 flex-col items-center justify-center rounded-full bg-white">
            <span className="font-serif text-lg font-bold text-emerald-800">87%</span>
          </div>
        </div>
        <div>
          <p className="font-serif text-lg font-semibold text-emerald-900">Compatibility</p>
          <p className="text-xs text-slate-500">Guidance, not a guarantee</p>
        </div>
      </div>
      <div className="space-y-2.5">
        {rows.map((r) => (
          <div key={r.label}>
            <div className="mb-1 flex justify-between text-xs text-slate-600"><span>{r.label}</span><span className="font-medium text-emerald-800">{r.val}%</span></div>
            <div className="h-1.5 rounded-full bg-mint"><div className="h-full rounded-full bg-emerald-600" style={{ width: `${r.val}%` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
